import { EXPERIENCE_FETCHING,
    EXPERIENCE_FAILED,
    EXPERIENCE_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching:false,
    isError: false
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case EXPERIENCE_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };
        case EXPERIENCE_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case EXPERIENCE_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        default:
            return state;
    }
};